<template>
    <div class="widthBox">
        <el-row :gutter="10" class="acea-row mt_80 row-between row-middle">
            <el-col :md="12" :xs="24" :sm="24">
		        <banner jsClass="item" :picS="goods_info.banner_list_url" :navigation="false" itemType="item"></banner>
            </el-col>
            <el-col :md="11" :xs="24" :sm="24">
                <h1 class="txt mt_24">{{goods_info.name}}</h1>
                <p class="info mt_16">{{goods_info.desc}}</p>
                <p class="txt mt_24" v-if="goods_info.sku">${{goods_info.sku.price}}</p>
                <div v-for="(item,index) in goods_info.instructions_list" :key="index">
                    <p class="info mt_16">{{item.name}}</p>
                    <p class="info mt_16">{{item.value}}</p>
                </div>
                <a target="_blank" href="http://phromonglobal.com" class="btn mt_40 radius-4">{{$t("Become an individual dealer")}}</a>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="acea-row mt_80 row-center">
            <el-col :md="15" :xs="24" :sm="22">
                <div v-html="goods_info.details" class="details"></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import banner from '@/components/banner.vue'
export default {
    name: "Products_details",
	components: {
		banner,
	},
    data() {
        return {
            id: 0,
            goods_info:{}
        }
    },
    mounted(){
        document.body.scrollIntoView();
    },
    created() {
        this.id = this.$route.query.id;
        this.get_info();
    },
    methods:{
        async get_info(){
            let res = await this.$api.get("api/Products/details", {id:this.id});
						if(res.code == 200){
							this.goods_info = res.data.goods_info;
						}else{
							this.$router.push({
								path:'/Products_index',
							})
						}
            console.log(res)
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
    .mt_80{
        margin-top: 80px;
    }
    .mt_16{
        margin-top: 16px;
    }
    .details{
        ::v-deep img{
            width: 100% !important;
            max-width:  100% !important;
        }
    }
        .mt_24{
            margin-top: 24px;
        }
    .mt_24{
        margin-top: 24px;
    }
    .mt_40{
        margin-top: 40px;
    }
    .mt_12{
        margin-top: 12px;
    }
    .btn{
        font-size: 20px;
        color: #Fff;
        padding: 16px 0;
        display: block;
        background: #b50900;
        text-align: center;
    }
    @media screen and(max-width:768px) {
        .mt_80{
            margin-top: 40px;
        }
        .mt_16{
            margin-top: 12px;
        }
        .mt_24{
            margin-top: 16px;
        }
        .mt_40{
            margin-top: 24px;
        }
        .mt_12{
            margin-top: 12px;
        }
    }
</style>